import React from 'react'
import { Outlet } from 'react-router-dom'

import SellerHeader from "../components/seller/SellerHeader"
import BuyerFooter from "../components/buyer/BuyerFooter"

function Layout() {
  return (
    <div>
      <SellerHeader />
      <div style={{ paddingTop: "15vh" }}>
        <Outlet />
      </div>
      <BuyerFooter />
    </div>
  )
}

export default Layout